/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShadowSubsystemAuditStep
 */
export interface ShadowSubsystemAuditStep {
    /**
     * 
     * @type {string}
     * @memberof ShadowSubsystemAuditStep
     */
    step: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowSubsystemAuditStep
     */
    detail: string;
    /**
     * 
     * @type {string}
     * @memberof ShadowSubsystemAuditStep
     */
    outcome: string;
}

/**
 * Check if a given object implements the ShadowSubsystemAuditStep interface.
 */
export function instanceOfShadowSubsystemAuditStep(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "step" in value;
    isInstance = isInstance && "detail" in value;
    isInstance = isInstance && "outcome" in value;

    return isInstance;
}

export function ShadowSubsystemAuditStepFromJSON(json: any): ShadowSubsystemAuditStep {
    return ShadowSubsystemAuditStepFromJSONTyped(json, false);
}

export function ShadowSubsystemAuditStepFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowSubsystemAuditStep {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'step': json['step'],
        'detail': json['detail'],
        'outcome': json['outcome'],
    };
}

export function ShadowSubsystemAuditStepToJSON(value?: ShadowSubsystemAuditStep | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'step': value.step,
        'detail': value.detail,
        'outcome': value.outcome,
    };
}

